import { Controller } from "stimulus";

export default class extends Controller {
  // TODO: 実装する
  // connect() {
  //   console.log("Hello, Stimulus!", this.element);
  // }
}
